exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.red {\n\tcolor: #f00;\n}\n", "", {"version":3,"sources":["/Users/ryanblaind/Dropbox/Work/dev/shopify-modern/src/views/HomeView.vue?e0f636c6"],"names":[],"mappings":";AAwBA;CACA,YAAA;CACA","file":"HomeView.vue","sourcesContent":["/*\n\tHome component shown at home\n*/\n\n<template>\n\t<div>\n\t\t<h1 class=\"red\">Home All</h1>\n\t</div>\n\n</template>\n\n\n<script>\n\texport default {\n\n\t\tdata () {\n\t\t\treturn {\n\t\t\t}\n\t\t}\n\t}\n</script>\n\n\n<style>\n\t.red {\n\t\tcolor: #f00;\n\t}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4addb74a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/HomeView.vue
// module id = 33
// module chunks = 0